import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { performPutRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { ProjectDetailsData, ProjectDetailsRequestBodySimplified } from './types';

export const constructEndpoint = (baseUrl: string, projectId: number) =>
	`/rest/internal/simplified/1.0/projects/${projectId}/summary`;

export const get =
	(baseUrl: string) =>
	(projectId: number): Promise<ProjectDetailsData> =>
		fetchJson(constructEndpoint(baseUrl, projectId));

export const put =
	(baseUrl: string) =>
	(projectId: number, data: ProjectDetailsRequestBodySimplified): Promise<ProjectDetailsData> => {
		const url = constructEndpoint(baseUrl, projectId);
		const options = {
			body: JSON.stringify(data),
		};
		return performPutRequest(url, options);
	};
